/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { RentalCarContract } from '../models';
/**
 * RentalCarContractApi - axios parameter creator
 * @export
 */
export const RentalCarContractApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a specific damage case rentalcarcontract uuid
         * @param {number} id The id of the damageCase to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRentalcarcontractGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRentalcarcontractGet', 'id', id)
            const localVarPath = `/damagecases/{id}/rentalcarcontract`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a rental car contract for a damage case
         * @param {number} id 
         * @param {RentalCarContract} [rentalCarContract] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRentalcarcontractPost: async (id: number, rentalCarContract?: RentalCarContract, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRentalcarcontractPost', 'id', id)
            const localVarPath = `/damagecases/{id}/rentalcarcontract`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rentalCarContract, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all RentalCarContracts
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarcontractGet: async (offset?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcarcontract`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a RentalCarContract
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarcontractIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rentalcarcontractIdGet', 'id', id)
            const localVarPath = `/rentalcarcontract/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update RentalCarContract
         * @param {number} id 
         * @param {RentalCarContract} [rentalCarContract] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarcontractIdPut: async (id: number, rentalCarContract?: RentalCarContract, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rentalcarcontractIdPut', 'id', id)
            const localVarPath = `/rentalcarcontract/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rentalCarContract, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RentalCarContractApi - functional programming interface
 * @export
 */
export const RentalCarContractApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RentalCarContractApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a specific damage case rentalcarcontract uuid
         * @param {number} id The id of the damageCase to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRentalcarcontractGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalCarContract>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRentalcarcontractGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a rental car contract for a damage case
         * @param {number} id 
         * @param {RentalCarContract} [rentalCarContract] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRentalcarcontractPost(id: number, rentalCarContract?: RentalCarContract, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalCarContract>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRentalcarcontractPost(id, rentalCarContract, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all RentalCarContracts
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarcontractGet(offset?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RentalCarContract>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarcontractGet(offset, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a RentalCarContract
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarcontractIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RentalCarContract>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarcontractIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update RentalCarContract
         * @param {number} id 
         * @param {RentalCarContract} [rentalCarContract] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarcontractIdPut(id: number, rentalCarContract?: RentalCarContract, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalCarContract>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarcontractIdPut(id, rentalCarContract, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RentalCarContractApi - factory interface
 * @export
 */
export const RentalCarContractApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RentalCarContractApiFp(configuration)
    return {
        /**
         * Get a specific damage case rentalcarcontract uuid
         * @param {number} id The id of the damageCase to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRentalcarcontractGet(id: number, options?: any): AxiosPromise<RentalCarContract> {
            return localVarFp.damagecasesIdRentalcarcontractGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a rental car contract for a damage case
         * @param {number} id 
         * @param {RentalCarContract} [rentalCarContract] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRentalcarcontractPost(id: number, rentalCarContract?: RentalCarContract, options?: any): AxiosPromise<RentalCarContract> {
            return localVarFp.damagecasesIdRentalcarcontractPost(id, rentalCarContract, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all RentalCarContracts
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarcontractGet(offset?: number, size?: number, options?: any): AxiosPromise<Array<RentalCarContract>> {
            return localVarFp.rentalcarcontractGet(offset, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a RentalCarContract
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarcontractIdGet(id: number, options?: any): AxiosPromise<Array<RentalCarContract>> {
            return localVarFp.rentalcarcontractIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update RentalCarContract
         * @param {number} id 
         * @param {RentalCarContract} [rentalCarContract] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarcontractIdPut(id: number, rentalCarContract?: RentalCarContract, options?: any): AxiosPromise<RentalCarContract> {
            return localVarFp.rentalcarcontractIdPut(id, rentalCarContract, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RentalCarContractApi - object-oriented interface
 * @export
 * @class RentalCarContractApi
 * @extends {BaseAPI}
 */
export class RentalCarContractApi extends BaseAPI {
    /**
     * Get a specific damage case rentalcarcontract uuid
     * @param {number} id The id of the damageCase to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarContractApi
     */
    public damagecasesIdRentalcarcontractGet(id: number, options?: AxiosRequestConfig) {
        return RentalCarContractApiFp(this.configuration).damagecasesIdRentalcarcontractGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a rental car contract for a damage case
     * @param {number} id 
     * @param {RentalCarContract} [rentalCarContract] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarContractApi
     */
    public damagecasesIdRentalcarcontractPost(id: number, rentalCarContract?: RentalCarContract, options?: AxiosRequestConfig) {
        return RentalCarContractApiFp(this.configuration).damagecasesIdRentalcarcontractPost(id, rentalCarContract, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all RentalCarContracts
     * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarContractApi
     */
    public rentalcarcontractGet(offset?: number, size?: number, options?: AxiosRequestConfig) {
        return RentalCarContractApiFp(this.configuration).rentalcarcontractGet(offset, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a RentalCarContract
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarContractApi
     */
    public rentalcarcontractIdGet(id: number, options?: AxiosRequestConfig) {
        return RentalCarContractApiFp(this.configuration).rentalcarcontractIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update RentalCarContract
     * @param {number} id 
     * @param {RentalCarContract} [rentalCarContract] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarContractApi
     */
    public rentalcarcontractIdPut(id: number, rentalCarContract?: RentalCarContract, options?: AxiosRequestConfig) {
        return RentalCarContractApiFp(this.configuration).rentalcarcontractIdPut(id, rentalCarContract, options).then((request) => request(this.axios, this.basePath));
    }
}
